import React, {memo, useMemo} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import {useLocalization} from "../../../../hooks/localization"
import iconCustomization from "../../../../assets/images/icons/settings/customization.png"
import iconScreen from "../../../../assets/images/icons/screen-menu.png"
import iconTheme from "../../../../assets/images/icons/theme.png"
import iconCleanPanel from "../../../../assets/images/icons/settings/ino-pan-clean.png"

import "./index.scss"

export const CustomMenu = memo(function CustomMenu() {
    const {t} = useLocalization()
    const CustomMenuRouters = useMemo(
        () => [
            {
                icon: iconCustomization,
                name: t("customizations.wallpaper"),
                path: "/settings/custom-menu/customization"
            },
            {
                icon: iconScreen,
                name: t("screen"),
                path: "/settings/custom-menu/screen-set/1"
            },
            {
                icon: iconTheme,
                name: t("customizations.theme"),
                path: "/settings/custom-menu/icon-theme"
            },
            {
                icon: iconCleanPanel,
                name: t("screen_clean_mode"),
                path: "/settings/custom-menu/screen-cleaner"
            }
        ],
        [t]
    )
    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"} style={null}>
                <div className="content-divider">
                    {CustomMenuRouters.map((control, index) => (
                        <SubMenuComponent key={index} icon={control.icon} name={control.name} path={control.path} />
                    ))}
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
